import { StyleSheet } from 'react-native';
import { tokens, TRANSPARENT } from '@airtel/air-design-system';
export var getOfferListWidgetStyles = props => {
  var _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? true : _props$showDivider;
  return StyleSheet.create({
    listItemWrapper: {
      marginVertical: showDivider ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_4
    },
    headItemWrapper: {
      marginVertical: tokens.spacing.SPACING_8,
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    expandSection: {
      marginBottom: tokens.spacing.SPACING_16
    },
    expandCta: {
      alignSelf: 'center',
      marginTop: tokens.spacing.SPACING_16
    },
    cardTitle: {
      paddingVertical: tokens.spacing.SPACING_8,
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    amountPayable: {
      borderColor: TRANSPARENT,
      paddingTop: tokens.spacing.SPACING_8,
      paddingBottom: tokens.spacing.SPACING_0
    },
    callout: {
      paddingHorizontal: tokens.spacing.SPACING_12
    },
    offerList: {
      marginVertical: tokens.spacing.SPACING_8,
      marginHorizontal: tokens.spacing.SPACING_16
    },
    veriticalMargin: {
      marginVertical: tokens.spacing.SPACING_8
    },
    suggestionRightSpace: {
      marginRight: tokens.spacing.SPACING_12
    }
  });
};